import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, StaticQuery } from 'gatsby'

class RecipeRoll extends React.Component {
  render() {
    const { data } = this.props
    const { edges: recipes } = data.allMarkdownRemark

    return (
      <div className="columns is-multiline">
        {recipes &&
          recipes.map(({ node: recipe }) => (
            <div className="is-parent column is-6" key={recipe.id}>
              <article
                className="blog-list-item tile is-child box notification"
              >
                <div>
                  <h3 className="heading-brand">
                    <Link
                      className="title has-text-primary is-size-4"
                      to={recipe.fields.slug}
                    >
                      {recipe.frontmatter.title}
                    </Link>
                  </h3>
                </div>
                <p>
                  {recipe.frontmatter.description}...
                  <br />
                  <Link className="button" to={recipe.fields.slug} 
                    style={{
                      margin: "0",
                      border: "2px solid #333",
                      borderRadius: "50px",
                      padding: "0.6rem 1.5rem",
                      lineHeight: "1",
                      height: "auto",
                      marginTop: "1rem",
                      textDecoration: "none",
                      fontSize: "16px",
                      fontFamily: "Kalam, cursive"
                    }}>
                    View recipe →
                  </Link>
                </p>
              </article>
            </div>
          ))}
      </div>
    )
  }
}

RecipeRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query RecipeRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "recipe" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                description
                title
                templateKey
                date(formatString: "MMMM DD, YYYY")
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 120, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <RecipeRoll data={data} count={count} />}
  />
)
